import { render } from "./Pie.vue?vue&type=template&id=5d9417ca&scoped=true"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"

import "./Pie.vue?vue&type=style&index=0&id=5d9417ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9417ca"]])

export default __exports__